<template>
  <div class="home">
    <header-menu v-if="headerState" :logo="logoUrl" />
    <router-view />
    <foot-menu v-if="footerState" />
    <Login v-if="loginModal.show" />
    <ComReg v-if="comRegModal.show" />
  </div>
</template>
<script>
import headerMenu from "@/components/pc/header.vue";
import footMenu from "@/components/pc/footer.vue";
import Login from "@/components/pc/login.vue";
import ComReg from "@/components/pc/comReg.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "pc-home",
  components: {
    headerMenu,
    footMenu,
    Login,
    ComReg
  },
  computed: {
    ...mapState(["loginModal", "comRegModal", "userInfo"]),
  },
  data() {
    return {
      headerState: true,
      footerState: true,
      logoUrl: '',
      deepLogoUrl:'',
      topNum:'',
    };
  },
  watch: {
    $route: {
      handler(newVal) {
        // console.log(newVal)
        const { headerIsShow, footerIsShow,topState } = newVal.meta;
        this.headerState = headerIsShow ? false : true;
        this.footerState = footerIsShow ? false : true;
        this.topNum =  topState ? true : false;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        
      },
      immediate: true,
    },
  },
  mounted() {
    this.getWebsiteInfo(); //获取网站配置信息
    this.urlState = window.location.host.includes("form_data")
      ? "false"
      : "true";
  },
  methods: {
    getWebsiteInfo() {
      
    },
  },
};
</script>

<style lang="scss">
 html,
      body {
        position: relative;
        // height: 100%;
      }
ul,li{
  list-style: none;
}
.flex {
  display: flex;
  align-items: center;
}
.cursor {
  cursor: pointer;
}
.none {
  display: none;
}
input::-webkit-input-placeholder {
  font-size: 14px;
}
input::-moz-input-placeholder {
  font-size: 14px;
}
input::-ms-input-placeholder {
  font-size: 14px;
}
.overflow_e {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  word-break: break-all; // 注意这个文字多行很重要
  -webkit-box-orient: vertical;
}
.abs_50{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.radius_5{
  border-radius: 5px;
}
.company-layer{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  .layer-content{
    width: 760px;
    padding-bottom: 20px;
    position: relative;
  }
  .layer-title{
    width: 100%;
    padding: 26px 34px;
    border-radius: 15px 15px 0 0;
    background: #2255AE;
    font-weight: bold;
    font-size: 24px;
    color: #FFFFFF;
  }
  .layer-list{
    padding: 0 34px;
    border-radius: 0 0 15px 15px;
    background: #FFFFFF;
    overflow: hidden;
  }
  .layer-info{
    width: 100%;
    padding: 25px 0;
    border-bottom: 1px dashed #CECECE;
    display: flex;
    align-items: flex-start;
    &:last-child{
      border: none;
    }
    &:nth-child(1){
      .layer-form{
        width: 100%;
      }
      .layer-form-text{
        width: 530px;
      }
    }
  }
  .layer-form{
    width: 50%;
    display: flex;
    align-items: flex-start;
  }
  .layer-form-title{
    width: 128px;
    font-weight: 500;
    font-size: 22px;
    color: #666666;
    display: flex;
    align-items: center;
    &::before{
      content: '';
      display: block;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background-color: #2255AE;
      margin-right: 10px;
    }
  }
  .layer-form-text{
    width: 200px;
    font-weight: bold;
    font-size: 22px;
    color: #333333;
  }
  .layer-close{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #FFFFFF;
    position: absolute;
    left: 50%;
    bottom: -100px;
    margin-left: -20px;
    cursor: pointer;
    &::before,
    &::after{
      content: '';
      display: block;
      width: 1px;
      height: 20px;
      background-color: #2255AE;
      position: absolute;
      top: 10px;
      left: 19px;
      transform: rotate(45deg);
    }
    &::before{
      transform: rotate(-45deg);
    }
  }
}
.no-data{
  width: 570px;
  margin: 20px auto;
}
.login_cont_box {
  background-size: 100% 100%;
  min-height: 100vh;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);

  .login_data {
    width: 506px;
    padding: 62px 80px 66px;
    background: #ffffff;
    border-radius: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .close {
      width: 20px;
      height: 20px;
      transform: rotate(45deg);
      cursor: pointer;
      position: absolute;
      top: 25px;
      right: 25px;
    }

    .tabs{
      display: flex;
      justify-content: center;
      margin-bottom: 50px;
      .tab{
        width: 50%;
        font-size: 25px;
        color: #666666;
        text-align: center;
        cursor: pointer;
        &.active{
          color: #2256AE;
          position: relative;
          &::after{
            content: '';
            display: block;
            width: 30px;
            height: 3px;
            background: #2256AE;
            border-radius: 2px;
            position: absolute;
            left: 50%;
            bottom: -13px;
            margin-left: -15px;
          }
        }
      }
    }

    .form_cont {
      ul {
        li {
          width: 100%;
          height: 48px;
          padding-left: 62px;
          border-radius: 5px;
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          position: relative;
          z-index: 0;
          &.user{
            background: url('@/assets/gd/user.png') no-repeat 15px center/17px #F2F4F8;
          }
          &.pass{
            background: url('@/assets/gd/lock.png') no-repeat 15px center/17px #F2F4F8;
          }
          &.phone{
            background: url('@/assets/gd/phone.png') no-repeat 15px center/17px #F2F4F8;
          }
          &.build{
            background: url('@/assets/gd/build.png') no-repeat 15px center/17px #F2F4F8;
          }
          &.card{
            background: url('@/assets/gd/card.png') no-repeat 15px center/17px #F2F4F8;
          }
          &.gonghui{
            background: url('@/assets/gd/gonghui.png') no-repeat 15px center/17px #F2F4F8;
          }
          input {
            width: 100%;
            height: 100%;
            background: none;
          }
          &.select{
            padding-right: 36px;
            z-index: 1;
            &::after{
              content: '';
              display: block;
              width: 36px;
              height: 36px;
              background: url('@/assets/gd/arrows.png') no-repeat center center/36px;
              position: absolute;
              right: 0;
              top: 50%;
              margin-top: -18px;
            }
            input{
              cursor: pointer;
            }
            .options{
              width: 100%;
              height: 180px;
              padding: 10px;
              overflow-y: auto;
              background: #FFFFFF;
              box-shadow: 0px 0px 6px 1px rgba(152,152,152,0.16);
              border-radius: 5px;
              position: absolute;
              top: 48px;
              left: 0;
              &::-webkit-scrollbar{
                width: 2px;
                background-color: #E1E1E1;
                border-radius: 2px;
              }
              &::-webkit-scrollbar-thumb{
                width: 100%;
                background-color: #2356AF;
              }
            }
            .option{
              font-size: 16px;
              color: #333333;
              margin-bottom: 20px;
              cursor: pointer;
              &:last-child{
                margin: 0;
              }
              &:hover,
              &.active{
                color: #2356AF;
              }
            }
            &.active{
              z-index: 1;
              &::after{
                transform: rotate(90deg);
              }
            }
          }
          &::before{
            content: '';
            display: block;
            width: 2px;
            height: 12px;
            background-color: #999;
            position: absolute;
            left: 47px;
            top: 19px;
          }
          
        }
      }

      .btn {
        width: 100%;
        height: 48px;
        background: #2356AF;
        border-radius: 5px;
        text-align: center;
        line-height: 48px;
        font-size: 20px;
        color: #FFFFFF;
        cursor: pointer;
        margin-bottom: 15px;
      }

      p.tips {
        text-align: center;
        font-size: 12px;
        color: #999;
      }
    }
  }
}
.layer-make{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  .make-content{
    width: 760px;
    position: relative;
  }
  .content-title{
    width: 100%;
    height: 85px;
    background: #2255AE;
    border-radius: 15px 15px 0 0;
    font-size: 24px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .content{
    width: 100%;
    padding: 30px 60px 60px;
    border-radius: 0 0 15px 15px;
    background-color: #fff;
  }
  .form{
    margin-bottom: 25px;
  }
  .form-title{
    font-size: 18px;
    color: #333333;
    margin-bottom: 10px;
  }
  .form-input,
  .form-textarea{
    width: 100%;
    height: 52px;
    padding: 0 15px;
    border-radius: 5px;
    border: 1px solid #2255AE;
  }
  .form-textarea{
    height: auto;
    padding: 15px;
  }
  .input,
  .textarea{
    width: 100%;
    height: 100%;
    font-size: 18px;
    resize: none;
  }
  .textarea{
    height: 144px;
  }
  .num{
    font-size: 14px;
    color: #999999;
    text-align: right;
  }
  .el-date-editor.el-input{
    width: 100% !important;
    .el-input__inner{
      border-color: #2255AE;
    }
  }
  .sub-btn{
    width: 259px;
    height: 50px;
    background: #2356AF;
    border-radius: 5px;
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
    text-align: center;
    line-height: 50px;
    margin: 50px auto 0;
    cursor: pointer;
  }
  .layer-close{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: url('@/assets/close_icon.png') no-repeat center center/20px #fff;
    transform: rotate(45deg);
    cursor: pointer;
    position: absolute;
    bottom: -90px;
    left: 50%;
    margin-left: -20px;
    cursor: pointer;
  }
}
</style>
